module.exports = __webpack_public_path__ + "img/logo.c710dd15.png";